module.exports = require('./lib/dom-scroll-into-view');



/*****************
 ** WEBPACK FOOTER
 ** ./~/rc-menu/~/dom-scroll-into-view/index.js
 ** module id = 226
 ** module chunks = 0 1
 **/